import colors from './colors'
import easing from './easing'
import fontWeights from './fontWeights'
import typography from './typography'

export default { colors, typography, fontWeights, easing }
